var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",style:({ backgroundColor: _vm.content.background_color, color: _vm.content.font_color, 'background-image': 'url(' + _vm.content.background_image + ')', 'font-size': _vm.content.font_size + 'px' }),domProps:{"innerHTML":_vm._s(_vm.content.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }